import { render, staticRenderFns } from "./LawsuitHistoryInformation.vue?vue&type=template&id=6460a5f0&scoped=true&"
import script from "./LawsuitHistoryInformation.vue?vue&type=script&lang=js&"
export * from "./LawsuitHistoryInformation.vue?vue&type=script&lang=js&"
import style0 from "./LawsuitHistoryInformation.vue?vue&type=style&index=0&id=6460a5f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6460a5f0",
  null
  
)

export default component.exports